import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import AppLayout from './components/layout/AppLayout';
import { UserRole } from './types';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OrganizationsPage from './pages/OrganizationsPage';
import DataFieldsPage from './pages/DataFieldsPage';
import QuestionnairesPage from './pages/QuestionnairesPage';
import QuestionnaireDetailPage from './pages/QuestionnaireDetailPage';
import ReportsPage from './pages/ReportsPage';
import MapsPage from './pages/MapsPage';
import ImportPage from './pages/ImportPage';
import ExportPage from './pages/ExportPage';
import SettingsPage from './pages/SettingsPage';
import LogsPage from './pages/LogsPage';
import DataPage from './pages/DataPage';
import FillQuestionnairePage from './pages/FillQuestionnairePage';
import MyQuestionnairesPage from './pages/MyQuestionnairesPage';
import ApiEndpointsPage from './pages/ApiEndpointsPage';
import DataSourcesPage from './pages/DataSourcesPage';
import ImportConfigPage from './pages/ImportConfigPage';
import WorkersPage from './pages/WorkersPage';
import UsersPage from './pages/UsersPage';
import InstancesPage from './pages/InstancesPage';
import AlarmplanPage from './pages/AlarmplanPage';
import AnonymousFillPage from './pages/AnonymousFillPage';
import DirectFillPage from './pages/DirectFillPage';

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  switch (user.role) {
    case UserRole.USER_INPUT:
    case UserRole.USER_VIEWER:
      return <Navigate to="/my" replace />;
    case UserRole.USER_EDITOR:
      return <Navigate to="/questionnaires" replace />;
    default:
      return <Dashboard />;
  }
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/fill/:token/anonymous" element={<AnonymousFillPage />} />

        {/* Protected routes with layout */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<RoleHome />} />
          <Route path="/organizations" element={<OrganizationsPage />} />
          <Route path="/fields" element={<DataFieldsPage />} />
          <Route path="/questionnaires" element={<QuestionnairesPage />} />
          <Route path="/fill/:token" element={<DirectFillPage />} />
          <Route path="/questionnaires/:id/fill" element={<FillQuestionnairePage />} />
          <Route path="/questionnaires/:id" element={<QuestionnaireDetailPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/maps" element={<MapsPage />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/import-configs" element={<ImportPage />} />
          <Route path="/workers" element={<ImportPage />} />
          <Route path="/api-endpoints" element={<ApiEndpointsPage />} />
          <Route path="/data-sources" element={<DataSourcesPage />} />
          <Route path="/export" element={<ExportPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/my" element={<MyQuestionnairesPage />} />
          <Route path="/data" element={<DataPage />} />
          <Route path="/logs" element={<LogsPage />} />
          <Route path="/instances" element={<InstancesPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/alarmplan" element={<AlarmplanPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
